import { styled } from '@mui/material';
import { Controller } from 'react-hook-form';

import Select from './Select';
import { type ControlledSelectProps } from './types';

const StyledSelect = styled(Select)`
    &.Mui-focused {
        background-color: rgb(0 0 255 / 0.1);
    }
` as typeof Select;

export const ControlledSelect = (props: ControlledSelectProps) => (
    <Controller
        name={props.name}
        control={props.control}
        defaultValue={props.defaultValue}
        render={({ field, fieldState }) => (
            <StyledSelect {...field} {...props} errorMessage={fieldState.error?.message}>
                {props.children}
            </StyledSelect>
        )}
    />
);

export default ControlledSelect;
